module.exports = __webpack_public_path__ + "img/en.22eec076.svg";